// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPrefundReplenishmentMinValuePropertyDto
 */
export interface IPrefundReplenishmentMinValuePropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IPrefundReplenishmentMinValuePropertyDto
     */
    prefund_replenishment_min_value?: number;
    /**
     * 
     * @type {string}
     * @memberof IPrefundReplenishmentMinValuePropertyDto
     */
    prefund_replenishment_min_value_state?: IPrefundReplenishmentMinValuePropertyDtoPrefundReplenishmentMinValueStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPrefundReplenishmentMinValuePropertyDtoPrefundReplenishmentMinValueStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IPrefundReplenishmentMinValuePropertyDto interface.
 */
export function instanceOfIPrefundReplenishmentMinValuePropertyDto(value: object): value is IPrefundReplenishmentMinValuePropertyDto {
    return true;
}

export function IPrefundReplenishmentMinValuePropertyDtoFromJSON(json: any): IPrefundReplenishmentMinValuePropertyDto {
    return IPrefundReplenishmentMinValuePropertyDtoFromJSONTyped(json, false);
}

export function IPrefundReplenishmentMinValuePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPrefundReplenishmentMinValuePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'prefund_replenishment_min_value': json['prefund_replenishment_min_value'] == null ? undefined : json['prefund_replenishment_min_value'],
        'prefund_replenishment_min_value_state': json['prefund_replenishment_min_value_state'] == null ? undefined : json['prefund_replenishment_min_value_state'],
    };
}

export function IPrefundReplenishmentMinValuePropertyDtoToJSON(json: any): IPrefundReplenishmentMinValuePropertyDto {
    return IPrefundReplenishmentMinValuePropertyDtoToJSONTyped(json, false);
}

export function IPrefundReplenishmentMinValuePropertyDtoToJSONTyped(value?: IPrefundReplenishmentMinValuePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prefund_replenishment_min_value': value['prefund_replenishment_min_value'],
        'prefund_replenishment_min_value_state': value['prefund_replenishment_min_value_state'],
    };
}

